import { EventEmitter } from 'node:events';

import type { Transport } from '@exodus/web3-types';

import { referrerURL } from '@/utils/referrer';

export const PROVIDER_RESPONSE_MESSAGE_TYPE = 'provider:response';

export type ProviderResponse = {
  type: string;
  input: string;
};

export const createTransport = (): Transport => {
  const transport = new EventEmitter() as unknown as Transport;

  transport.write = (input) => {
    window.parent.postMessage(
      {
        type: PROVIDER_RESPONSE_MESSAGE_TYPE,
        input,
      } satisfies ProviderResponse,
      __STANDALONE_MODE__ ? window.origin : referrerURL,
    );
  };

  return transport;
};
